export default __webpack_public_path__ + "static/media/award4.e96db60e.svg";